import { getVArticleIds } from '../actions/get-v-articles.action';

export async function fetchVArticleMap(articleIds: string[], ctx: any): Promise<Record<string, boolean>> {
    const list = await getVArticleIds(articleIds, ctx);
    const map: Record<string, boolean> = {};
    for (const id of articleIds) {
        map[id] = false;
    }

    for (const v of list) {
        const s = (v ?? '').trim();
        if (!s) {
            continue;
        }

        const base = s.endsWith('V') ? s.slice(0, -1) : s;
        if (base in map) {
            map[base] = true;
        }
    }
    return map;
}
